<template>
  <div class="activity-container">
    <div class="base-flex base-margin__bottom-10">
      <el-button type="primary" @click="describeClusterActivities">
        {{ $t('computingCluster.activity.refresh') }}
      </el-button>
      <!-- 状态筛选下拉框（已注释） -->
      <!--<el-select
        v-model="statusList"
        class="select-status base-margin__left-10"
        clearable
        collapse-tags
        multiple
        :placeholder="$t('computingCluster.activity.selectStatus')"
        @change="describeClusterActivities"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>-->
    </div>

    <!-- 活动列表表格 -->
    <el-table
      ref="expandTable"
      v-loading="tableLoading"
      :data="manageData"
      class="activity-table"
      @row-click="handleRowClick"
    >
      <!-- 展开行 -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="details">
            <div class="base-margin__left-20" @click="getSubclusterActivityDetails(scope.row)">
              <span class="base-color__light_blue base-cursor__pointer">
                [{{ $t('computingCluster.activity.viewActivityLog') }}]
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <!-- 用户名列 -->
      <el-table-column :label="$t('computingCluster.activity.userName')">
        <template slot-scope="scope">
          <span>{{ scope.row?.userName || '-' }}</span>
        </template>
      </el-table-column>

      <!-- 活动类型列 -->
      <el-table-column :label="$t('computingCluster.activity.activityType')">
        <template slot-scope="scope">
          <p>{{ scope.row.action || '-' }}</p>
        </template>
      </el-table-column>

      <!-- 状态列 -->
      <el-table-column :label="$t('computingCluster.activity.status')">
        <template slot-scope="scope">
          <p>{{ processStatus(scope.row.activityState) || '-' }}</p>
        </template>
      </el-table-column>

      <!-- 开始时间列 -->
      <el-table-column :label="$t('computingCluster.activity.startTime')">
        <template slot-scope="scope">
          {{ scope.row.createTime || '-' }}
        </template>
      </el-table-column>

      <!-- 结束时间列 -->
      <el-table-column :label="$t('computingCluster.activity.endTime')">
        <template slot-scope="scope">
          {{ scope.row.endTime || '-' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 活动详情对话框 -->
    <el-dialog
      :title="$t('computingCluster.activity.activityDetails')"
      :visible.sync="showDetailInfoVisible"
      width="1000px"
    >
      <div class="base-margin__left-20">
        <p>{{ detailInfo }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {postRequest} from '@/common/libs/request';

export default {
  name: 'activity',
  components: {},
  data() {
    return {
      date: '',
      total: 0,
      searchInput: '',
      currentPage: 1,
      limit: 10,
      manageData: [], // 活动列表数据
      expands: [], // 展开的行
      showDetailInfoVisible: false, // 是否显示详情对话框
      detailInfo: '', // 详情信息
      statusOptions: [ // 状态筛选选项
        {label: this.$t('computingCluster.activity.executing'), value: '1'},
        {label: this.$t('computingCluster.activity.executionSucceeded'), value: '2'},
        {label: this.$t('computingCluster.activity.partiallySucceeded'), value: '3'},
        {label: this.$t('computingCluster.activity.executionFailed'), value: '4'},
      ],
      statusList: [], // 选中的状态列表
      tableLoading: false, // 表格加载状态
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      this.currentPage = 1;
      this.limit = 10;
      this.describeClusterActivities();
    },
  },
  mounted() {
    this.describeClusterActivities();
  },
  methods: {
    /**
     * 表格行点击事件处理
     * @param {Object} row - 当前点击的行数据
     * 切换行的展开/收起状态
     */
    handleRowClick(row) {
      row.expanded = !row.expanded;
      this.$refs.expandTable.toggleRowExpansion(row, row.expanded);
    },

    /**
     * 每页显示数量变化处理
     * @param {number} limit - 新的每页显示数量
     * 重置当前页码并重新获取数据
     */
    handleSizeChange(limit) {
      if (limit === this.limit) {
        return;
      }
      this.currentPage = 1;
      this.limit = limit;
      this.describeClusterActivities();
    },

    /**
     * 当前页码变化处理
     * @param {number} page - 新的页码
     * 重新获取数据
     */
    handleCurrentChange(page) {
      this.currentPage = page;
      this.describeClusterActivities();
    },

    /**
     * 获取集群活动列表
     * 1. 计算分页偏移量
     * 2. 发送请求获取活动列表
     * 3. 更新表格数据
     */
    describeClusterActivities() {
      this.tableLoading = true;
      const offset = this.limit * (this.currentPage - 1);
      const data = {
        offset,
        limit: this.limit,
      };
      postRequest('/api/eda/common/cluster/getClsLogList', data)
        .then((res) => {
          this.manageData = res.list || [];
          this.total = res.total || 0;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    /**
     * 处理活动状态显示
     * @param {number} val - 状态值
     * @returns {string} 状态对应的文本
     */
    processStatus(val) {
      switch (val) {
        case 1:
          return this.$t('computingCluster.activity.executing');
        case 2:
          return this.$t('computingCluster.activity.executionSucceeded');
        case 3:
          return this.$t('computingCluster.activity.partiallySucceeded');
        case 4:
          return this.$t('computingCluster.activity.executionFailed');
        default:
          return '-';
      }
    },

    /**
     * 获取活动详情
     * @param {Object} subclusterActivity - 活动数据
     * 显示活动详情对话框
     */
    getSubclusterActivityDetails(subclusterActivity) {
      this.detailInfo = subclusterActivity?.detail || '';
      this.showDetailInfoVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-container {
  height: 100%;
}

.activity-head {
  height: 32px;
  margin-bottom: 20px;
  display: none;
}

.activity-table {
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}

.refresh {
  padding: 0;
  font-size: 20px;
}

.details {
  padding: 0 20px;
}

.select-status {
  width: 240px !important;
  margin-right: 10px;

  ::v-deep .el-input {
    width: 240px !important;
  }
}
</style>
